export const queryKey = {
  all: ['material', 'variation', 'preselect'] as const,
  detail: (variationId: number) => [...queryKey.all, variationId] as const,
};
